/* unplugin-vue-components disabled */import { render } from "./ExamTicket.vue?vue&type=template&id=0cf7859d&ts=true"
import script from "./ExamTicket.vue?vue&type=script&lang=ts"
export * from "./ExamTicket.vue?vue&type=script&lang=ts"

import "./ExamTicket.vue?vue&type=style&index=0&id=0cf7859d&lang=less"

import exportComponent from "/work/release/ug-fe-contest-student/node_modules/.pnpm/vue-loader@16.7.0_@vue+compiler-sfc@3.2.23_vue@3.2.23_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])